import { ErrorMessages } from '../types/errors';

export const ERRORS_TO_SHOW = [
  'conekta.errors.processing.bank.insufficient_funds',
  'conekta.errors.processing.bank.declined',
  'conekta.errors.processing.charge.card_payment.suspicious_behaviour',
  'conekta.errors.parameter_validation.card.forbidden_mcc_sivale',
  'conekta.errors.processing.charge.card_payment.declined_by_3ds',
  'conekta.errors.parameter_validation.charge.international_card_not_allowed',
  'conekta.errors.parameter_validation.charge.risk_validation_amount_reaching',
  'conekta.errors.processing.bank.call_issuer',
  'conekta.errors.parameter_validation.charge.blocked_payment_source',
  'conekta.errors.precondition_required.combo.order.cannot_be_updated_because_has_charge_paid',
  'conekta.errors.precondition_required.combo.order.cannot_be_updated_because_has_charge',
  'conekta.errors.parameter_validation.charge.credit_forbidden_mcc',
  'conekta.errors.parameter_validation.card.restricted_bank_18_msi_only',
  'conekta.errors.parameter_validation.card.forbidden_mcc_rappi',
  'conekta.errors.parameter_validation.charge.forbidden_card_for_company',
  'conekta.errors.parameter_validation.charge.cash_payment.oxxo_payment.disabled',
  'conekta.errors.parameter_validation.charge.bank_payment.spei_payment.disabled',
  'conekta.errors.parameter_validation.combo.order.currency_type.card.maximum',
  'conekta.errors.processing.bank.timeout',
  'conekta.errors.processing.bank.amount_over_limit',
  'conekta.errors.processing.bank.invalid_expiration_date',
  'conekta.errors.parameter_validation.charge.monthly_installments_not_supported_for_international_cards',
];

export const DEFAULT_INTERNAL_ERROR_MESSAGE = 'errors.internal';
export const DEFAULT_BUSINESS_ERROR_MESSAGE = 'errors.business';
export const DEFAULT_LANGUAGE = 'es';
export const ERROR_NETWORK_CODE = 'ERR_NETWORK';

/**
 * How long any single request may take before axios aborts it. Applies to every call sharing
 * axiosInstance, so it has to clear the slowest legitimate one (a bank authorization on
 * capture), not just the quick 3DS hops.
 */
export const REQUEST_TIMEOUT_MS = 60_000;

/** ECONNABORTED is what the xhr adapter raises on timeout; ETIMEDOUT with clarifyTimeoutError. */
export const TIMEOUT_ERROR_CODES = ['ECONNABORTED', 'ETIMEDOUT'];

export const ERROR_MESSAGES: ErrorMessages = {
  en: {
    'errors.internal': 'An unexpected error has occurred, please try again.',
    'errors.business': 'Please try another payment method.',
  },
  es: {
    'errors.internal': 'Ha ocurrido un error inesperado, por favor intente de nuevo.',
    'errors.business': 'La tarjeta ingresada ha sido declinada. Por favor intenta con otro método de pago.',
  },
};

export const MAX_RETRIES = 2;

export enum ErrorStatus {
  EMPTY_RESPONSE = 0,
  INTERNAL_SERVER_ERROR = 500,
  BUSINESS_ERROR = 400,
  NOT_FOUND = 404,
}
